// extracted by mini-css-extract-plugin
export default {"reportBox":"accidentReport_reportBox__KWgGd","searchBox":"accidentReport_searchBox__Fs-8N","analysisMap":"accidentReport_analysisMap__mQNjz","innerTitle":"accidentReport_innerTitle__ljimI","tableOperateColumn":"accidentReport_tableOperateColumn__JajTl"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"reportBox\":\"accidentReport_reportBox__KWgGd\",\"searchBox\":\"accidentReport_searchBox__Fs-8N\",\"analysisMap\":\"accidentReport_analysisMap__mQNjz\",\"innerTitle\":\"accidentReport_innerTitle__ljimI\",\"tableOperateColumn\":\"accidentReport_tableOperateColumn__JajTl\"}";
        // 1793842499727
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  